import { apolloClient } from '~/apollo-client';
import {
  Flex_UpdateMultiUtilityAccountMutation,
  Flex_UpdateMultiUtilityAccountMutationVariables,
  UtilityAccountInput,
} from '~/typings/graphql';
import { UPDATE_MULTI_UTILITY_ACCOUNT } from './update-multi-utility-account.queries';

export interface UpdateMultiUtilityAccountParams {
  planId: number;
  utilityAccounts: UtilityAccountInput[];
}

export type UpdateMultiUtilityAccountResponse = {
  id: number;
};
export const updateMultiUtilityAccount = async (
  params: UpdateMultiUtilityAccountParams,
): Promise<UpdateMultiUtilityAccountResponse> => {
  const { data } = await apolloClient.mutate<
    Flex_UpdateMultiUtilityAccountMutation,
    Flex_UpdateMultiUtilityAccountMutationVariables
  >({
    mutation: UPDATE_MULTI_UTILITY_ACCOUNT,
    variables: {
      planId: params.planId,
      input: {
        utilityAccounts: [...params.utilityAccounts],
      },
    },
  });

  const id = data?.multiUtilityAccountEnrollment?.id;
  if (id == null) {
    throw new Error('updateMultiUtilityAccount: no id returned from mutation');
  }
  return { id };
};
